import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./lib/api";

const it = {
  "nav.game": "Homepage",
  "nav.streamers": "Streamer",
  "nav.eventi": "Eventi",
  "nav.news": "Patch Notes",
  "nav.classifica": "Classifica",
  "nav.youtube": "Bulkhead",
  "nav.giveaway": "Giveaway",
  "nav.donazione": "Donazione",
  "nav.discord": "Discord",
  "disc.f1t": "Annunci in tempo reale",
  "disc.f1x": "Live, eventi, giveaway e novità su WARDOGS arrivano prima qui che altrove.",
  "disc.f2t": "Trova la tua squadra",
  "disc.f2x": "Canali vocali per schieramento e ricerca gruppo: non scenderai mai in campo da solo.",
  "disc.f3t": "Supporto e community",
  "disc.f3x": "Domande sul gioco, sul sito o sui giveaway: lo staff e la community rispondono qui.",
  "nav.staff": "Staff",
  "home.welcome_over": "// OPERATORE IN SERVIZIO",
  "cont.over": "// CANALE DIRETTO CON LO STAFF",
  "cont.title": "Contattaci",
  "cont.sub": "Problemi, sponsor, richieste: c'è una casella di posta vera, presidiata ogni giorno.",
  "cont.post_title": "Come raggiungerci",
  "cont.body": "Per qualsiasi problema con il sito o con l'account, proposte di sponsorizzazione e partnership, richieste su eventi, giveaway o collaborazioni con il progetto WARDOGS Italian Gamer, scrivici liberamente: leggiamo e rispondiamo a tutti, il prima possibile.",
  "cont.mail_btn": "Scrivici una email",
  "cont.copy_hint": "Il pulsante apre in automatico il tuo servizio email; in caso di problemi, copia l'indirizzo qui sotto e scrivici come preferisci.",
  "cont.copied": "Email copiata: wigfounder@gmail.com",
  "footer.contatti": "Contattaci",
  "home.welcome": "Bentornato, {name}",
  "home.welcome_faction": "Schieramento attivo: {role}",
  "home.welcome_norole": "Non hai ancora scelto il tuo schieramento — il registro ti aspetta.",
  "home.welcome_profile": "Vai al profilo",
  "home.welcome_choose": "Scegli lo schieramento",
  "nav.login": "Accedi",
  "nav.login_twitch": "Accedi con Twitch",
  "nav.logout": "Esci",
  "release.over": "// EARLY ACCESS — 10 SETTEMBRE 2026, ORE 18:00",
  "release.title": "IN LIVE SU WARDOGS",
  "release.sub": "Il countdown è iniziato: il 10 settembre 2026 alle 18:00 (ora italiana) WARDOGS arriva in Early Access e si scende finalmente in campo.",
  "release.live": "IL GIOCO È LIVE — SCENDI IN CAMPO ORA",
  "release.cta": "Gioca ora su Steam",
  "profile.over": "// SCHEDA OPERATORE",
  "profile.title": "Il tuo profilo",
  "profile.streak": "Giorni consecutivi sul sito",
  "profile.streak_badge": "Badge Fedeltà — {n} giorni di fila",
  "profile.drops": "I tuoi Twitch Drop",
  "profile.drops_text": "I drop di WARDOGS si collegano dal portale ufficiale del gioco: accedi con il tuo account, collega Twitch e guarda le live per sbloccare le ricompense.",
  "profile.drops_cta": "Vai ad account.wardogs.com",
  "profile.theme": "Tema del sito",
  "profile.theme_dark": "Scuro",
  "profile.theme_light": "Chiaro",
  "profile.account": "Account collegato",
  "profile.via": "Accesso tramite {provider}",
  "don.over": "// DONAZIONE",
  "don.title": "Offri una razione al Quartiermastro",
  "don.text": "Il sito, gli eventi e i giveaway crescono grazie alla community. Se vuoi dare una mano, ogni donazione libera va diretta al progetto.",
  "don.note": "Donazione libera e sicura tramite PayPal — puoi donare anche senza account PayPal, con carta.",
  "don.pool_note": "La colletta è gestita interamente da PayPal: il sito non vede mai i tuoi dati di pagamento. Dopo la donazione avvisa lo staff su Discord: ti ringraziamo pubblicamente e il tuo nome entra nel muro qui sotto.",
  "don.cta": "Dona con PayPal",
  "don.paypal_text": "Un click e la razione parte: con PayPal la donazione è istantanea, protetta e senza pensieri — puoi donare anche senza account, direttamente con la tua carta. Ogni euro va dritto nella war room: server, eventi, giveaway e premi per la community. Chi sostiene il Quartiere lascia il segno sul muro dei ringraziamenti qui sotto.",
  "profile.no_password": "Con l'accesso tramite Twitch o Google non esiste una password del sito da modificare: se dimentichi le credenziali le recuperi direttamente dal provider (Twitch o Google).",
  "profile.sub_badge": "Abbonato",
  "profile.sub_tier": "Tier {n}",
  "sub.full": "Abbonato · T{n}",
  "sub.title": "Abbonato al canale Twitch — Tier {n} (le sub Prime contano come T1)",
  "profile.recheck": "Ricontrolla abbonamento",
  "profile.rechecking": "Verifica in corso...",
  "profile.recheck_ok": "Abbonamento confermato: sei riconosciuto!",
  "profile.recheck_ko": "Nessun abbonamento attivo trovato sul canale.",
  "profile.recheck_relogin": "Sessione Twitch scaduta o assente: esci e rientra con Twitch (o collegalo dai social qui sotto), poi ricontrolla.",
  "profile.discord_toast_linked": "Discord collegato — ruolo fazione sincronizzato.",
  "profile.discord_toast_clash": "Questo account Discord è già collegato a un altro profilo del sito.",
  "profile.discord_toast_own": "Questo Discord ha già un suo account sul sito: accedi direttamente con Discord.",
  "profile.discord_toast_error": "Collegamento Discord non riuscito. Riprova.",
  "profile.discord_toast_unlinked": "Discord scollegato e ruoli fazione rimossi dal server.",
  "com.role_discord_ok": "Ruolo {role} assegnato anche sul server Discord!",
  "com.role_discord_no": "Per ricevere il ruolo sul server Discord, collega l'account Discord dal tuo profilo.",
  "com.role_discord_notmember": "Non risulti nel server Discord: entra prima dall'invito nella pagina Discord, poi riseleziona la fazione.",
  "com.role_discord_error": "Ruolo Discord non sincronizzato (errore temporaneo) — la fazione sul sito è comunque salvata.",
  "gv.twitch_required": "I giveaway sono riservati agli abbonati Twitch: accedi con l'account Twitch abbonato per partecipare.",
  "gv.subinfo": "Il login Twitch rileva automaticamente l'abbonamento al canale principale IlQuartiermastro e sblocca l'area Giveaway riservata agli abbonati",
  "gv.share": "Condividi",
  "gv.share_sub": "Fai sapere a tutti che c'è un premio in palio: più siamo, più giveaway arrivano.",
  "gv.share_copied": "Link e dettagli del giveaway copiati — incollali dove vuoi.",
  "gv.share_note": "Su Discord e WhatsApp il link mostra automaticamente l'anteprima con titolo e premio.",
  "share.site_text": "WARDOGS.HQ — Il quartier generale italiano di WARDOGS: guida al gioco, fazioni, giveaway e streamer",
  "badge.t1": "Recluta",
  "badge.t5": "Soldato",
  "badge.t10": "Caporale",
  "badge.t20": "Sergente",
  "badge.t30": "Sergente Maggiore",
  "badge.t40": "Maresciallo",
  "badge.t50": "Tenente",
  "badge.t65": "Capitano",
  "badge.t80": "Maggiore",
  "badge.t90": "Colonnello",
  "badge.t100": "Centurione",
  "badge.day": "giorno {n}/100",
  "badge.donor": "Donatore",
  "don.wall_others": "// E GRAZIE ANCHE A",
  "don.wall_others_empty": "I prossimi sostenitori appariranno qui — ogni donazione conta, grande o piccola.",
  "share.opening": "Testo copiato — si apre {social}: incolla e pubblica!",
  "share.copy_link": "Copia link",
  "share.link_copied": "Link copiato — incollalo dove vuoi.",
  "profile.socials_title": "Account social collegati",
  "profile.socials_text": "Collega i tuoi account social con un clic: autorizzi sul sito ufficiale del social e il collegamento avviene in automatico. Collegando YouTube attivi anche l'accesso con Google (è lo stesso account). Poi, quando condividi il sito o un giveaway, ti apriamo direttamente la tua pagina pronta a pubblicare. Su Discord il collegamento attiva anche il ruolo della tua fazione sul server.",
  "profile.socials_save": "Salva collegamenti",
  "profile.socials_saved": "Collegamenti social salvati.",
  "profile.socials_connect": "Collega",
  "profile.socials_unlink": "Scollega",
  "profile.socials_linked_as": "Collegato come {name}",
  "profile.socials_soon": "In attivazione",
  "profile.socials_linked": "{social} collegato al tuo profilo.",
  "profile.socials_error": "Collegamento {social} non riuscito. Riprova.",
  "profile.tiktok_help_title": "TikTok non ha completato il collegamento",
  "profile.tiktok_help_text": "Nessun dato è stato toccato. Riprova da una finestra in incognito di Chrome, senza estensioni o ad-blocker attivi: i blocchi anti-tracciamento impediscono a TikTok di riportarti qui dopo l'accesso. Se usi il QR code, conferma dal telefono e attendi qualche secondo sulla pagina. L'app è stata approvata da TikTok da pochissimo: se il problema persiste, attendi qualche ora e riprova.",
  "profile.socials_clash": "Questo account {social} è già collegato a un altro profilo del sito.",
  "profile.socials_own_twitch": "Sei già dentro con il tuo account Twitch: è il tuo accesso principale.",
  "profile.socials_primary": "Accesso principale",
  "profile.socials_unlinked_done": "{social} scollegato dal profilo.",
  "hero.overline": "BULKHEAD × TEAM17 — EARLY ACCESS 2026",
  "hero.line1": "Nati per",
  "hero.line2": "Passione.",
  "hero.line3": "Mai per obbligo.",
  "hero.sub": "Siamo nati grazie alla passione per WARDOGS, il nuovo FPS mil-sim di Bulkhead. Non siamo un clan: giochiamo per divertirci e per passione, senza obblighi, senza orari fissi, senza allenamenti, senza presenze obbligatorie. Una community over 30, tra mogli, mariti, figli e gli impegni di tutti i giorni.",
  "pub.post_full": "🎖️ WARDOGS ITALIAN GAMER — wardogsitaliangamer.it\n\nPremessa onesta: non siamo un clan.\nNiente tryout, niente allenamenti, niente appuntamenti obbligatori. Il tag WIG, se ti va di aggiungerlo, è solo un segno visivo di appartenenza — nulla di più.\n\nSiamo una community di adulti 30+ che giocano a WARDOGS: tra lavoro, famiglia e impegni quotidiani, quando c'è un'ora libera la passiamo insieme sul fronte.\n\nQuello che trovi sul sito, gratis e senza obblighi:\n\n⚔️ La tua fazione (Lonestar, Valkyra, Manticore) con ruolo Discord automatico e gradi da Recluta a Centurione\n🏆 La classifica community con le tue statistiche Steam\n🎁 I giveaway riservati agli abbonati Twitch\n📰 Le news ufficiali BULKHEAD e Steam tradotte in italiano\n📺 Il calendario live del Quartiermastro e le funny clip\n💛 Il muro dei ringraziamenti per chi sostiene il progetto\n\nNessuna pressione: entri quando vuoi, giochi quando puoi.\nIl 10 settembre WARDOGS entra in Early Access — se cerchi compagni di squadra con la testa sulle spalle, ci trovi qui.\n\n👉 wardogsitaliangamer.it\n💬 discord.gg/tvK39PpRqv",
  "nav.lagofast": "LagoFast",
  "lago.over": "// partner ufficiale",
  "lago.title": "LAGOFAST",
  "lago.text": "**+ FPS − PING − LATENZA**\n\nGioca a WARDOGS abbassando la latenza e il ping e aumentando i tuoi FPS. Prendi il vantaggio in modo 100% legale grazie a **LagoFast**, il booster di gioco potente, affidabile ed economico che usiamo anche noi!\n\n• Ping più basso su tutti i server\n• Latenza ridotta: gioco fluido e stabile\n• Più FPS, più vantaggio\n• VPN inclusa\n\n**Fai la prova gratuita**: se ti trovi bene, usa il nostro link partner insieme al codice sconto esclusivo per risparmiare il **30%** sul tuo abbonamento. Non dimenticare di risparmiare!",
  "lago.cta": "Prova LagoFast Gratis",
  "lago.url": "https://www.lagofast.com/en/refer/?cid=8166806",
  "lago.code": "ILMASTRO",
  "lago.code_label": "// codice sconto esclusivo −30%",
  "lago.copy": "Copia codice",
  "lago.copied": "Copiato!",
  "home.sponsor.over": "// partner ufficiale",
  "home.sponsor.title": "Vinci senza lag con LagoFast",
  "home.sponsor.sub": "Codice ILMASTRO: −30% sull'abbonamento",
  "home.sponsor.cta": "Scopri l'offerta",
  "pub.post_short": "🎖️ WARDOGS ITALIAN GAMER — la community italiana 30+ di WARDOGS. Niente clan né obblighi: fazioni, classifiche Steam, giveaway e live. Entri quando vuoi, giochi quando puoi.\n👉 wardogsitaliangamer.it 💬 discord.gg/tvK39PpRqv",
  "hero.discord_cta": "La guerra si vince insieme — entra nel Discord",
  "hero.cta1": "Scegli il tuo schieramento",
  "hero.cta2": "WARDOGS su Steam",
  "live.now": "IN LIVE ORA",
  "live.watch": "Guarda la live",
  "live.viewers": "{n} spettatori",
  "guide.over": "// MANUALE DI CAMPO",
  "guide.title": "Come si gioca a WARDOGS",
  "guide.intro": "La guida del Quartiermastro: tutto quello che devi sapere prima di scendere in campo, direttamente dalla nostra recensione dopo ore di gioco.",
  "g1.title": "La battaglia",
  "g1.text": "100 giocatori si suddividono in tre fazioni e si scontrano su mappe in larga scala. Le partite durano da un'ora in su: non una scaramuccia, una campagna.",
  "g2.title": "Zona di controllo",
  "g2.text": "Una zona di controllo enorme domina la mappa: per vincere, la tua fazione deve avere al suo attivo più soldati delle altre, guadagnando punti ogni 10 secondi circa.",
  "g3.title": "Hot zone",
  "g3.text": "Un cerchio giallo che si sposta a caso dentro la zona di controllo: restarci dentro moltiplica x2 i soldi, le presenze conteggiate e i punti di qualsiasi azione. E non siete i soli a volerci stare.",
  "g4.title": "Le torri",
  "g4.text": "Torri inizialmente vuote da conquistare per ottenere un singolo codice numerico. Conquista quelle delle altre fazioni, completa il codice e inseriscilo nella console di una tua torre: attirerai la hot zone e regalerai guadagni moltiplicati a tutta la fazione.",
  "g5.title": "Audio di guerra",
  "g5.text": "Suoni perfetti, realistici, grezzi, veri: i passi SI SENTONO DAVVERO. Esplosioni mozzafiato quando un missile da mortaio ti arriva vicino o un elicottero esplode a pochi metri, per non parlare dei colpi di cannone dei carri armati.",
  "g6.title": "Squadre e voci",
  "g6.text": "Nessun limite di membri: puoi fare una squadra da 20 persone e parlare solo tra voi. La chat di prossimità fa il resto: nemici che cantano, scherzano e muoiono, in diretta.",
  "g7.title": "Libertà totale",
  "g7.text": "Niente classi rigide: appostati su un tetto con lo sniper e farai crescere il Ricognitore; rianima un compagno di tua iniziativa e riceverai molti soldi ed exp per la classe Medico; imbraccia il martello e costruisci ciò che serve per aumentare la classe Supporto. Ogni azione ha conseguenze dirette sulle classi.",
  "g8.title": "Progressione meritata",
  "g8.text": "Per sbloccare accessori non basta il livello account: servono i livelli delle sei classi — Supporto, Assalitore, Medico, Ricognitore, Conducente e Pilota.",
  "g9.title": "Non è COD, non è Battlefield",
  "g9.text": "Niente slide, salti continui o super sprint: WARDOGS si avvicina ad Arena Breakout: Infinite ed Escape From Tarkov, senza però arrivare a un hardcore così marcato. Se ami gli FPS tattici dove la coesione e la collaborazione la fanno da padrone, che tu sia in singolo o con un team, scendi in campo e non te ne pentirai.",
  "g10.title": "Early access onesta",
  "g10.text": "BULKHEAD non monetizzerà il gioco durante l'Early Access, non venderà MAI valuta di gioco o lingotti — si ottengono solo giocando — e non permetterà MAI di comprare mimetiche: devono dimostrare impegno, non portafoglio. Serietà rara, traguardi premiati davvero.",
  "g10.video": "Il video dei DEV — 10 motivi per NON comprare WARDOGS",
  "standings.today": "arruolati oggi",
  "events.over": "// EVENTI COMMUNITY",
  "events.title": "Prossimo appuntamento",
  "events.none": "Nessun evento programmato — gli annunci arrivano prima su Discord",
  "events.days": "giorni",
  "events.hours": "ore",
  "events.min": "min",
  "events.sec": "sec",
  "events.join": "Partecipa",
  "drops.over": "// TWITCH DROPS",
  "drops.title": "Campagne drop attive",
  "drops.none": "Nessuna campagna drop attiva al momento — appena BULKHEAD ne attiva una, la trovi qui",
  "drops.ends": "Termina il {date}",
  "drops.claim": "Riscatta su Twitch",
  "media.over": "// MEDIA DAL FRONTE",
  "media.title": "Dal campo di battaglia",
  "discord.over": "// QUARTIER GENERALE DISCORD",
  "discord.title1": "Entra nel nostro",
  "discord.title2": "Discord ufficiale e gioca con noi",
  "discord.text": "Strategie, squadre, annunci sugli eventi e i giveaway: tutto passa dal nostro Discord. Guarda chi è online in tempo reale e unisciti alla compagnia.",
  "discord.join": "Unisciti al Discord",
  "discord.pending": "Invito Discord in arrivo — configurazione in corso",
  "discord.radar": "Il radar utenti si attiva non appena colleghiamo l'ID del server Discord",
  "pulse.members": "soldati arruolati",
  "pulse.online": "online adesso",
  "pulse.online_title": "Chi c'è adesso",
  "pulse.online_sub": "Presenze in tempo reale dal server — lo staff brilla in arcobaleno",
  "pulse.voice_title": "In guerra adesso (canali vocali)",
  "pulse.voice_empty": "Nessuno in vocale al momento: le sale aspettano, fai rumore tu per primo.",
  "pulse.ann_title": "Ultimi annunci dal server",
  "pulse.live_banner": "IL QUARTIERMASTRO È IN DIRETTA",
  "pulse.live_sub": "Guarda la live e poi entra nella chat vocale del server",
  "pulse.watch": "GUARDA LA LIVE",
  "pulse.realtime": "si aggiorna da solo ogni 30 secondi",
  "pulse.just": "adesso",
  "pulse.min_ago": "min fa",
  "pulse.hours_ago": "h fa",
  "pulse.days_ago": "g fa",
  "pulse.missing_title": "Ti manca solo la chat vocale",
  "pulse.missing_sub": "Sei già dei nostri sul sito — ma la guerra vera si parla nel server Discord: entra, presentati e trova la tua squadra.",
  "pulse.missing_cta": "Entra adesso",
  "gp.title": "In campo adesso",
  "gp.world": "persone su WARDOGS in tutto il mondo",
  "gp.world_soon": "Dal lancio del gioco, qui vedrai in diretta quante persone in tutto il mondo stanno giocando a WARDOGS in questo momento",
  "gp.members": "membri della community in partita ora",
  "gp.none": "Nessuno della community in partita al momento — il campo aspetta, tocca a te.",
  "gp.play": "GIOCA ANCHE TU",
  "pn.title": "WARDOGS Patch Notes",
  "pn.sub": "Annunci e aggiornamenti ufficiali BULKHEAD, raccolti in automatico dalla nostra pattuglia — qui arrivano prima che altrove.",
  "pn.open": "Leggi su Steam",
  "pn.badge": "Nuova patch",
  "pn.badge_sub": "Aggiornamento ufficiale WARDOGS appena pubblicato",
  "pn.badge_cta": "Leggi le patch notes",
  "wr.title": "Rapporto di guerra",
  "wr.week": "Settimana",
  "wr.hours": "ore in campo questa settimana",
  "wr.active": "operativi attivi",
  "wr.climbers": "Scalatori della settimana",
  "wr.none": "Il primo rapporto arriva domenica sera.",
  "donate.over": "// SOSTIENI IL PROGETTO",
  "donate.title": "Offri una razione al Quartiermastro",
  "donate.text": "Il sito, gli eventi e i giveaway crescono grazie alla community. Se vuoi dare una mano, ogni donazione libera va diretta al progetto.",
  "donate.cta": "Dona con PayPal",
  "donate.pending": "Le donazioni PayPal arrivano a breve",
  "footer.tag": "Community hub italiano non ufficiale dedicato a WARDOGS, lo sparatutto tattico di BULKHEAD pubblicato da Team17.",
  "footer.nav": "Navigazione",
  "footer.sources": "Fonti ufficiali",
  "footer.admin": "Area Staff",
  "footer.legal": "Fan project — non affiliato a BULKHEAD o Team17",
  "footer.copy": "© 2026 IlQuartiermastro · WARDOGS Italian Gamer — Tutti i contenuti di questo sito sono di proprietà esclusiva. Vietata ogni copia o riproduzione non autorizzata.",
  "str.over": "// CANALE PRINCIPALE DEL PROGETTO",
  "str.schedule_title": "Programmazione Live",
  "str.schedule_empty": "Nessuna data in calendario al momento — il Quartiermastro aggiorna la programmazione di settimana in settimana.",
  "str.sched_today": "Oggi",
  "str.sched_tomorrow": "Domani",
  "str.kind_live": "Live",
  "str.kind_off": "Niente live",
  "str.kind_special": "Speciale",
  "str.text": "Il comando operativo della community WARDOGS. Live, eventi, anteprime e i giveaway ufficiali: tutto parte da qui.",
  "str.status": "Stato canale",
  "str.follow": "Segui per non perdere le live",
  "str.sub_note": "Gli abbonati al canale sbloccano l'accesso ai giveaway del quartier generale. La verifica avviene automaticamente con il login Twitch.",
  "str.open": "Apri su Twitch",
  "str.subscribe": "Abbonati — sblocca i giveaway",
  "str.live": "IN LIVE",
  "str.offline": "OFFLINE",
  "str.partners_over": "// STREAMER PARTNER",
  "str.partners_title": "La squadriglia cresce",
  "str.partners_text": "Gli streamer partner del progetto vengono aggiunti mano a mano che entrano nella compagnia. Vuoi unirti? Scrivici su Discord.",
  "str.slot": "Slot libero",
  "str.slot_sub": "Prossimo partner in arrivo",
  "str.watch": "Guarda la live",
  "yt.over": "// ARCHIVIO VIDEO — CANALE UFFICIALE BULKHEAD",
  "yt.title1": "L'archivio",
  "yt.title2": "BULKHEAD",
  "yt.text": "Ogni video pubblicato dalla software house su WARDOGS viene caricato qui in automatico, direttamente dal canale YouTube ufficiale.",
  "yt.sync": "Sincronizzazione archivio…",
  "yt.live": "Feed live — {n} video sincronizzati",
  "yt.down": "Archivio temporaneamente non raggiungibile",
  "yt.latest": "Ultimo caricamento",
  "yt.watch": "Guarda su YouTube",
  "yt.play": "Riproduci",
  "yt.channel": "Vai al canale BULKHEAD",
  "com.over": "// REGISTRO DELLA COMMUNITY",
  "com.title1": "Scegli il tuo",
  "com.title2": "schieramento",
  "com.text": "Giura fedeltà a uno dei tre schieramenti e il tuo nome entrerà nel registro pubblico del quartier generale. La fazione scelta può essere cambiata una volta ogni 30 giorni.",
  "com.gate_title": "Entra nel quartier generale",
  "com.gate_text": "Accedi con Twitch, Google o Discord, scegli il tuo schieramento e sblocca i vantaggi riservati agli operatori. Un click e sei dei nostri.",
  "com.welcome": "Operatore {name} — seleziona uno schieramento",
  "com.cooldown": "Fazione attiva: {role} — potrai cambiare schieramento tra {days} giorni (un cambio ogni 30 giorni)",
  "com.discord_notice_title": "Ruolo fazione su Discord",
  "com.discord_notice_text": "Vuoi il ruolo della tua fazione sul server Discord? Collega il tuo account Discord dal Profilo: il ruolo Lonestar, Valkyra o Manticore ti viene assegnato in automatico. Se hai già scelto la fazione, il ruolo arriva appena colleghi l'account.",
  "com.discord_notice_cta": "Collega Discord",
  "com.assigned": "Schieramento assegnato: {role}",
  "com.locked_toast": "Cambio bloccato: potrai cambiare schieramento tra {n} giorni.",
  "com.error": "Impossibile assegnare lo schieramento.",
  "com.auth_ok": "Accesso effettuato. Benvenuto al quartier generale.",
  "com.auth_denied": "Accesso Twitch annullato.",
  "com.active": "▸ Schieramento attivo",
  "com.locked": "▸ Cambio bloccato (30 giorni)",
  "com.select": "▸ Seleziona",
  "com.roster_over": "// REGISTRO OPERATORI",
  "com.roster_title": "Il muro degli schieramenti",
  "com.enrolled": "{n} operatori arruolati",
  "com.waiting": "In attesa di reclute",
  "com.ops": "{n} OP",
  "com.new_badge": "Nuovo",
  "com.today_names": "Entrati oggi (login Twitch / Google / Discord)",
  "role.lonestar.desc": "Precisione chirurgica. Gli occhi e il fucile dello schieramento.",
  "role.valkyra.desc": "Furia d'assalto. Prima linea, primo impatto, ultima parola.",
  "role.manticore.desc": "Supporto e controllo. La schiena coperta, sempre.",
  "gv.over": "// DEPOSITO RICOMPENSE",
  "gv.title": "Il deposito giveaway",
  "gv.text": "Le ricompense sono visibili a tutti, ma il deposito si apre solo per gli abbonati al canale Twitch del Quartiermastro — verifica automatica, esattamente come su Discord.",
  "gv.active": "Giveaway attivo",
  "gv.soon": "In preparazione",
  "gv.loading": "Caricamento ricompensa…",
  "gv.prize": "Premio",
  "gv.entries": "{n} partecipanti",
  "gv.login_title": "Accesso richiesto",
  "gv.login_text": "Accedi con Twitch: controlleremo in automatico il tuo abbonamento al canale.",
  "gv.in_title": "Sei dentro",
  "gv.in_text": "Partecipazione registrata, {name}. Il vincitore sarà estratto live sul canale.",
  "gv.unlocked": "Deposito sbloccato",
  "gv.subs_title": "Riservato agli abbonati",
  "gv.subs_text": "Cliccando \"Partecipa\" verifichiamo il tuo abbonamento a twitch.tv/ilquartiermastro tramite l'API ufficiale di Twitch.",
  "gv.enter": "Partecipa al giveaway",
  "gv.checking": "Verifica abbonamento…",
  "gv.sub_link": "Non sei abbonato? Abbonati qui",
  "gv.how1t": "Accedi con Twitch",
  "gv.how1x": "Un click, nessuna password nuova: usiamo il tuo account Twitch.",
  "gv.how2t": "Verifica automatica",
  "gv.how2x": "L'API Twitch conferma l'abbonamento al canale in tempo reale.",
  "gv.how3t": "Estrazione live",
  "gv.how3x": "Il vincitore viene estratto in diretta sul canale del Quartiermastro.",
  "gv.past": "Giveaway passati",
  "gv.winner": "Vincitore: {name}",
  "gv.no_winner": "Estrazione non ancora avvenuta",
  "gv.drawing": "Estrazione in corso — la ruota sta girando",
  "gv.wheel_sub": "I nomi girano… la ruota rallenta e si fermerà sul vincitore",
  "gv.winner_is": "Il vincitore è",
  "gv.winner_sub": "Congratulazioni! Lo staff ti contatterà su Discord o Twitch per la consegna del premio",
  "gv.sound_on": "Attiva i suoni del giveaway",
  "gv.sound_off": "Disattiva i suoni del giveaway",
  "gv.showcase_label": "Ultimo vincitore della community",
  "gv.showcase_won": "Si aggiudica",
  "gv.showcase_next": "Nessun giveaway attivo ora — il prossimo è in preparazione, torna presto",
  "gv.hof": "Hall of Fame — i vincitori dei giveaway",
  "gv.hof_last": "Ultimo vincitore",
  "gv.audio_hint": "Clicca o tocca la pagina una volta per attivare i suoni del giveaway",
  "gv.audio_overlay": "Clicca per attivare l'audio della ruota",
  "gv.audio_skip": "guarda senza audio",
  "gv.fair": "Estrazione casuale crittografica su {n} iscritti — pari probabilità per tutti",
  "gv.wheel_ready": "Ogni iscritto prende il suo spicchio sulla ruota — si aggiorna in automatico a ogni nuova iscrizione",
  "gv.volume": "Volume suoni",
  "gv.under_pointer": "Sotto la lancetta",
  "gv.joined": "è salito sulla ruota!",
  "gv.toast_in": "Partecipazione confermata. Buona fortuna!",
  "gv.toast_already": "Sei già dentro: buona fortuna, operatore.",
  "gv.toast_notsub": "Serve un abbonamento attivo al canale per partecipare.",
  "gv.toast_relogin": "Sessione Twitch scaduta: esci e riaccedi con Twitch, poi riprova. Se sei abbonato (anche con Prime) entrerai senza problemi.",
  "gv.toast_error": "Errore durante la partecipazione.",
  "g10.p1": "NON monetizzeremo il gioco in nessun momento durante l'Accesso anticipato.",
  "g10.p2": "NON monetizzeremo MAI il denaro di gioco o i lingotti d'oro: si ottengono solo giocando.",
  "g10.p3": "NON permetteremo MAI di acquistare direttamente le mimetiche: devono dimostrare l'impegno di chi le ha sbloccate, non i soldi.",
  "gv.none": "Nessun giveaway attivo al momento — il prossimo è in preparazione",
  "gv.participants": "Partecipanti",
  "gv.no_participants": "Nessun partecipante ancora — sii il primo a entrare",
  "gv.scheduled_badge": "Apertura programmata",
  "gv.starts_in": "Le iscrizioni si aprono tra",
  "gv.not_open": "Il deposito è sigillato: le iscrizioni si aprono in automatico allo scadere del countdown.",
  "gv.toast_notopen": "Le iscrizioni non sono ancora aperte.",
  "clips.over": "// FUNNY CLIP",
  "clips.title": "Le clip del Quartiermastro",
  "clips.text": "I momenti più assurdi e spettacolari delle live, pescati in automatico dal canale Twitch.",
  "clips.by": "clip di {name}",
  "clips.views": "{n} visualizzazioni",
  "clips.none": "Nessuna clip disponibile al momento — i momenti migliori delle live appariranno qui in automatico.",
  "profile.visits": "Accessi totali",
  "profile.badges_title": "Gradi di fedeltà — 10 livelli",
  "profile.badge_next": "Prossimo grado a {n} accessi",
  "profile.badge_max": "Grado massimo raggiunto",
  "steam.title": "Account Steam",
  "steam.text_off": "Collega il tuo account Steam per mostrare ore di gioco, achievement e statistiche di WARDOGS. Steam non riceve né condivide la tua password: l'accesso avviene sul sito ufficiale di Steam.",
  "steam.link": "Collega account Steam",
  "steam.hours": "Ore su WARDOGS",
  "steam.achievements": "Achievement sbloccati",
  "steam.stats": "Statistiche di gioco",
  "steam.no_stats": "Il gioco non pubblica ancora statistiche su Steam — appariranno qui in automatico appena disponibili.",
  "steam.not_owned": "WARDOGS non ancora rilevato nella tua libreria Steam.",
  "steam.private": "Il tuo profilo Steam è privato: alcuni dati potrebbero non essere visibili.",
  "steam.refresh": "Aggiorna",
  "steam.unlink": "Scollega",
  "steam.view": "Profilo Steam",
  "steam.toast_linked": "Account Steam collegato.",
  "steam.toast_error": "Collegamento Steam non riuscito. Riprova.",
  "steam.toast_clash": "Questo account Steam è già collegato a un altro utente.",
  "steam.toast_unlinked": "Account Steam scollegato.",
  "member.back": "Torna al registro",
  "member.notfound": "Operatore non trovato",
  "member.since": "Nel registro dal {date}",
};

const en = {
  "nav.game": "Homepage",
  "nav.streamers": "Streamers",
  "nav.news": "Patch Notes",
  "nav.eventi": "Events",
  "nav.classifica": "Leaderboard",
  "nav.youtube": "Bulkhead",
  "nav.giveaway": "Giveaway",
  "nav.donazione": "Donate",
  "nav.discord": "Discord",
  "disc.f1t": "Real-time announcements",
  "disc.f1x": "Streams, events, giveaways and WARDOGS news land here before anywhere else.",
  "disc.f2t": "Find your squad",
  "disc.f2x": "Faction voice channels and looking-for-group: you'll never deploy alone.",
  "disc.f3t": "Support and community",
  "disc.f3x": "Questions about the game, the site or giveaways: staff and community answer here.",
  "nav.staff": "Staff",
  "home.welcome_over": "// OPERATOR ON DUTY",
  "cont.over": "// DIRECT LINE TO THE STAFF",
  "cont.title": "Contact us",
  "cont.sub": "Issues, sponsors, requests: a real inbox, checked every day.",
  "cont.post_title": "How to reach us",
  "cont.body": "For any problem with the site or your account, sponsorship and partnership proposals, requests about events, giveaways or collaborations with the WARDOGS Italian Gamer project, write to us freely: we read and reply to everyone, as soon as possible.",
  "cont.mail_btn": "Send us an email",
  "cont.copy_hint": "The button automatically opens your email app; if you have any trouble, copy the address below and write to us however you prefer.",
  "cont.copied": "Email copied: wigfounder@gmail.com",
  "footer.contatti": "Contact us",
  "home.welcome": "Welcome back, {name}",
  "home.welcome_faction": "Active faction: {role}",
  "home.welcome_norole": "You haven't picked your faction yet — the registry awaits.",
  "home.welcome_profile": "Go to profile",
  "home.welcome_choose": "Pick your faction",
  "nav.login": "Sign in",
  "nav.login_twitch": "Sign in with Twitch",
  "nav.logout": "Log out",
  "release.over": "// EARLY ACCESS — SEPTEMBER 10, 2026, 6:00 PM",
  "release.title": "LIVE ON WARDOGS",
  "release.sub": "The countdown has begun: on September 10, 2026 at 6:00 PM (Italian time) WARDOGS hits Early Access and we finally deploy.",
  "release.live": "THE GAME IS LIVE — DEPLOY NOW",
  "release.cta": "Play now on Steam",
  "profile.over": "// OPERATOR CARD",
  "profile.title": "Your profile",
  "profile.streak": "Consecutive days on site",
  "profile.streak_badge": "Loyalty Badge — {n} days in a row",
  "profile.drops": "Your Twitch Drops",
  "profile.drops_text": "WARDOGS drops are linked from the game's official portal: sign in with your account, connect Twitch and watch the streams to unlock the rewards.",
  "profile.drops_cta": "Go to account.wardogs.com",
  "profile.theme": "Site theme",
  "profile.theme_dark": "Dark",
  "profile.theme_light": "Light",
  "profile.account": "Linked account",
  "profile.via": "Signed in via {provider}",
  "don.over": "// DONATION",
  "don.title": "Buy the Quartermaster a ration",
  "don.text": "The site, events and giveaways grow thanks to the community. If you want to lend a hand, every free donation goes straight into the project.",
  "don.note": "Free and secure donation via PayPal — you can donate even without a PayPal account, by card.",
  "don.pool_note": "The money pool is handled entirely by PayPal: this site never sees your payment data. After donating, ping the staff on Discord: we'll thank you publicly and your name goes on the wall below.",
  "don.cta": "Donate with PayPal",
  "don.paypal_text": "One click and the ration is on its way: with PayPal your donation is instant, protected and worry-free — you can donate even without an account, straight from your card. Every euro goes straight into the war room: servers, events, giveaways and prizes for the community. Those who support the HQ leave their mark on the thank-you wall below.",
  "profile.no_password": "With Twitch or Google sign-in there is no site password to change: if you forget your credentials, recover them directly from the provider (Twitch or Google).",
  "profile.sub_badge": "Subscriber",
  "profile.sub_tier": "Tier {n}",
  "sub.full": "Subscriber · T{n}",
  "sub.title": "Channel subscriber — Tier {n} (Prime subs count as T1)",
  "profile.recheck": "Re-check subscription",
  "profile.rechecking": "Checking...",
  "profile.recheck_ok": "Subscription confirmed: you're recognized!",
  "profile.recheck_ko": "No active subscription found on the channel.",
  "profile.recheck_relogin": "Twitch session expired or missing: log out and back in with Twitch (or link it from the socials below), then re-check.",
  "profile.discord_toast_linked": "Discord linked — faction role synced.",
  "profile.discord_toast_clash": "This Discord account is already linked to another site profile.",
  "profile.discord_toast_own": "This Discord already has its own site account: sign in directly with Discord.",
  "profile.discord_toast_error": "Discord linking failed. Try again.",
  "profile.discord_toast_unlinked": "Discord unlinked and faction roles removed from the server.",
  "com.role_discord_ok": "{role} role assigned on the Discord server too!",
  "com.role_discord_no": "To receive the role on the Discord server, link your Discord account from your profile.",
  "com.role_discord_notmember": "You're not in the Discord server: join first via the invite on the Discord page, then re-select your faction.",
  "com.role_discord_error": "Discord role not synced (temporary error) — your site faction is saved anyway.",
  "gv.twitch_required": "Giveaways are reserved for Twitch subscribers: sign in with the subscribed Twitch account to enter.",
  "gv.subinfo": "Twitch login automatically detects your subscription to the main channel IlQuartiermastro and unlocks the subscriber-only Giveaway area",
  "gv.share": "Share",
  "gv.share_sub": "Let everyone know there's a prize up for grabs: the more we are, the more giveaways will come.",
  "gv.share_copied": "Giveaway link and details copied — paste them anywhere.",
  "gv.share_note": "On Discord and WhatsApp the link automatically shows a preview with title and prize.",
  "share.site_text": "WARDOGS.HQ — The Italian WARDOGS headquarters: game guide, factions, giveaways and streamers",
  "badge.t1": "Recruit",
  "badge.t5": "Private",
  "badge.t10": "Corporal",
  "badge.t20": "Sergeant",
  "badge.t30": "Staff Sergeant",
  "badge.t40": "Warrant Officer",
  "badge.t50": "Lieutenant",
  "badge.t65": "Captain",
  "badge.t80": "Major",
  "badge.t90": "Colonel",
  "badge.t100": "Centurion",
  "badge.day": "day {n}/100",
  "badge.donor": "Donor",
  "don.wall_others": "// AND THANKS ALSO TO",
  "don.wall_others_empty": "The next supporters will appear here — every donation counts, big or small.",
  "share.opening": "Text copied — opening {social}: paste and post!",
  "share.copy_link": "Copy link",
  "share.link_copied": "Link copied — paste it anywhere.",
  "profile.socials_title": "Linked social accounts",
  "profile.socials_text": "Link your social accounts with one click: you authorize on the social's official site and the connection happens automatically. Linking YouTube also enables Google sign-in (it's the same account). Then, when you share the site or a giveaway, we open your page ready to post. On Discord, linking also activates your faction role on the server.",
  "profile.socials_save": "Save links",
  "profile.socials_saved": "Social links saved.",
  "profile.socials_connect": "Connect",
  "profile.socials_unlink": "Unlink",
  "profile.socials_linked_as": "Linked as {name}",
  "profile.socials_soon": "Coming soon",
  "profile.socials_linked": "{social} linked to your profile.",
  "profile.socials_error": "Linking {social} failed. Try again.",
  "profile.tiktok_help_title": "TikTok didn't complete the link",
  "profile.tiktok_help_text": "No data was touched. Try again from a Chrome incognito window with no extensions or ad-blockers: anti-tracking blocks prevent TikTok from bringing you back here after login. If you use the QR code, confirm on your phone and wait a few seconds on the page. The app was approved by TikTok very recently: if the issue persists, wait a few hours and retry.",
  "profile.socials_clash": "This {social} account is already linked to another site profile.",
  "profile.socials_own_twitch": "You're already signed in with your Twitch account: it's your main sign-in.",
  "profile.socials_primary": "Main sign-in",
  "profile.socials_unlinked_done": "{social} unlinked from your profile.",
  "hero.overline": "BULKHEAD × TEAM17 — EARLY ACCESS 2026",
  "hero.line1": "Born of",
  "hero.line2": "Passion.",
  "hero.line3": "Never duty.",
  "hero.sub": "We were born from our passion for WARDOGS, Bulkhead's new mil-sim FPS. We're not a clan: we play for fun and for the love of the game — no obligations, no fixed hours, no training, no mandatory attendance. An over-30 community of husbands, wives, kids and everyday life.",
  "pub.post_full": "🎖️ WARDOGS ITALIAN GAMER — wardogsitaliangamer.it\n\nAn honest premise: we're not a clan.\nNo tryouts, no training sessions, no mandatory appointments. The WIG tag, if you feel like adding it, is just a visible sign of belonging — nothing more.\n\nWe're a community of 30+ adults playing WARDOGS: between work, family and daily commitments, when there's a free hour we spend it together on the frontline.\n\nWhat you find on the site, free and with no obligations:\n\n⚔️ Your faction (Lonestar, Valkyra, Manticore) with automatic Discord role and ranks from Recruit to Centurion\n🏆 The community leaderboard with your Steam stats\n🎁 Giveaways reserved for Twitch subscribers\n📰 Official BULKHEAD and Steam news translated into Italian\n📺 The Quartermaster's live calendar and funny clips\n💛 The wall of thanks for those who support the project\n\nNo pressure: join whenever you want, play when you can.\nOn September 10 WARDOGS enters Early Access — if you're looking for level-headed squadmates, you'll find us here.\n\n👉 wardogsitaliangamer.it\n💬 discord.gg/tvK39PpRqv",
  "pub.post_short": "🎖️ WARDOGS ITALIAN GAMER — the Italian 30+ WARDOGS community. No clan, no obligations: factions, Steam leaderboards, giveaways and live streams. Join whenever you want, play when you can.\n👉 wardogsitaliangamer.it 💬 discord.gg/tvK39PpRqv",
  "nav.lagofast": "LagoFast",
  "lago.over": "// official partner",
  "lago.title": "LAGOFAST",
  "lago.text": "**+ FPS − PING − LATENCY**\n\nPlay WARDOGS with lower latency, lower ping and higher FPS. Get the edge — 100% legal — with **LagoFast**, the powerful, reliable and affordable game booster we use ourselves!\n\n• Lower ping on every server\n• Reduced latency: smooth, stable gameplay\n• More FPS, more advantage\n• VPN included\n\n**Start the free trial**: if you like it, use our partner link together with the exclusive discount code to save **30%** on your subscription. Don't forget to save!",
  "lago.cta": "Try LagoFast For Free",
  "lago.url": "https://www.lagofast.com/en/refer/?cid=8166806",
  "lago.code": "ILMASTRO",
  "lago.code_label": "// exclusive discount code −30%",
  "lago.copy": "Copy code",
  "lago.copied": "Copied!",
  "home.sponsor.over": "// official partner",
  "home.sponsor.title": "Win without lag with LagoFast",
  "home.sponsor.sub": "Code ILMASTRO: −30% off your subscription",
  "home.sponsor.cta": "See the deal",
  "hero.discord_cta": "War is won together — join the Discord",
  "hero.cta1": "Choose your faction",
  "hero.cta2": "WARDOGS on Steam",
  "live.now": "LIVE NOW",
  "live.watch": "Watch the stream",
  "live.viewers": "{n} viewers",
  "guide.over": "// FIELD MANUAL",
  "guide.title": "How WARDOGS is played",
  "guide.intro": "The Quartermaster's guide: everything you need to know before deploying, straight from our review after hours in the field.",
  "g1.title": "The battle",
  "g1.text": "100 players split into three factions and clash on large-scale maps. Matches last an hour or more: not a skirmish, a campaign.",
  "g2.title": "Control zone",
  "g2.text": "A huge control zone dominates the map: to win, your faction must have more soldiers inside it than the others, earning points roughly every 10 seconds.",
  "g3.title": "Hot zone",
  "g3.text": "A yellow circle that moves randomly within the control zone: staying inside doubles your money, your counted presence and the points of any action. And you're not the only ones who want in.",
  "g4.title": "The towers",
  "g4.text": "Initially empty towers to capture, each holding a single numeric code. Take the other factions' towers, complete the code and enter it into the console of one of yours: you will pull the hot zone towards you and grant multiplied earnings to your entire faction.",
  "g5.title": "War audio",
  "g5.text": "Perfect, realistic, raw, true sounds: footsteps you REALLY hear. Breathtaking explosions when a mortar round lands next to you or a helicopter blows up nearby — let alone tank cannon fire.",
  "g6.title": "Squads and voices",
  "g6.text": "No member cap: you can run a 20-man squad with private comms. Proximity chat does the rest: enemies singing, joking and dying, live.",
  "g7.title": "Total freedom",
  "g7.text": "No rigid classes: camp a rooftop with a sniper and your Recon grows; revive a teammate on your own initiative and you'll earn plenty of money and XP for the Medic class; grab the hammer and build what's needed to level up the Support class. Every action directly shapes your classes.",
  "g8.title": "Earned progression",
  "g8.text": "Unlocking attachments takes more than account level: you need levels in the six classes — Support, Assault, Medic, Recon, Driver and Pilot.",
  "g9.title": "Not COD, not Battlefield",
  "g9.text": "No slides, no bunny hops, no super sprint: WARDOGS is closer to Arena Breakout: Infinite and Escape From Tarkov, without going full hardcore. If you love tactical FPS games where cohesion and teamwork rule — whether solo or with a squad — jump into the field and you won't regret it.",
  "g10.title": "Honest early access",
  "g10.text": "BULKHEAD will not monetize the game during Early Access, will NEVER sell in-game currency or gold bars — they are earned by playing only — and will NEVER let anyone buy camos: they must prove commitment, not wallet. Rare integrity, with achievements truly rewarded.",
  "g10.video": "The DEVs' own video — 10 reasons NOT to buy WARDOGS",
  "standings.today": "enlisted today",
  "events.over": "// COMMUNITY EVENTS",
  "events.title": "Next appointment",
  "events.none": "No events scheduled — announcements land on Discord first",
  "events.days": "days",
  "events.hours": "hours",
  "events.min": "min",
  "events.sec": "sec",
  "events.join": "Join",
  "drops.over": "// TWITCH DROPS",
  "drops.title": "Active drop campaigns",
  "drops.none": "No drop campaign active right now — as soon as BULKHEAD enables one, you'll find it here",
  "drops.ends": "Ends {date}",
  "drops.claim": "Claim on Twitch",
  "media.over": "// FRONTLINE MEDIA",
  "media.title": "From the battlefield",
  "discord.over": "// DISCORD HEADQUARTERS",
  "discord.title1": "Join our official",
  "discord.title2": "Discord and play with us",
  "discord.text": "Strategies, squads, event and giveaway announcements: everything happens on our Discord. See who's online in real time and join the company.",
  "discord.join": "Join the Discord",
  "discord.pending": "Discord invite coming soon — being configured",
  "discord.radar": "The member radar activates once we link the Discord server ID",
  "pulse.members": "enlisted soldiers",
  "pulse.online": "online now",
  "pulse.online_title": "Who's here right now",
  "pulse.online_sub": "Real-time presence from the server — staff shines in rainbow",
  "pulse.voice_title": "In battle now (voice channels)",
  "pulse.voice_empty": "Nobody in voice right now: the rooms are waiting, make some noise first.",
  "pulse.ann_title": "Latest server announcements",
  "pulse.live_banner": "THE QUARTERMASTER IS LIVE",
  "pulse.live_sub": "Watch the stream, then jump into the server's voice chat",
  "pulse.watch": "WATCH THE STREAM",
  "pulse.realtime": "auto-refreshes every 30 seconds",
  "pulse.just": "now",
  "pulse.min_ago": "min ago",
  "pulse.hours_ago": "h ago",
  "pulse.days_ago": "d ago",
  "pulse.missing_title": "You're only missing the voice chat",
  "pulse.missing_sub": "You're already one of us on the site — but the real war talk happens in the Discord server: jump in, say hi and find your squad.",
  "pulse.missing_cta": "Join now",
  "gp.title": "In the field now",
  "gp.world": "people on WARDOGS worldwide",
  "gp.world_soon": "When the game launches, a live counter will show here how many people worldwide are playing WARDOGS right now",
  "gp.members": "community members in a match right now",
  "gp.none": "Nobody from the community is in a match right now — the field is waiting, it's your call.",
  "gp.play": "PLAY NOW",
  "pn.title": "WARDOGS Patch Notes",
  "pn.sub": "Official BULKHEAD announcements and updates, collected automatically by our patrol — they land here before anywhere else.",
  "pn.open": "Read on Steam",
  "pn.badge": "New patch",
  "pn.badge_sub": "Official WARDOGS update just published",
  "pn.badge_cta": "Read the patch notes",
  "wr.title": "War Report",
  "wr.week": "Week",
  "wr.hours": "hours in the field this week",
  "wr.active": "active operatives",
  "wr.climbers": "Climbers of the week",
  "wr.none": "The first report arrives on Sunday evening.",
  "donate.over": "// SUPPORT THE PROJECT",
  "donate.title": "Buy the Quartermaster a ration",
  "donate.text": "The site, events and giveaways grow thanks to the community. If you want to lend a hand, every free donation goes straight into the project.",
  "donate.cta": "Donate with PayPal",
  "donate.pending": "PayPal donations coming soon",
  "footer.tag": "Unofficial Italian community hub dedicated to WARDOGS, the tactical shooter by BULKHEAD published by Team17.",
  "footer.nav": "Navigation",
  "footer.sources": "Official sources",
  "footer.admin": "Staff Area",
  "footer.legal": "Fan project — not affiliated with BULKHEAD or Team17",
  "footer.copy": "© 2026 IlQuartiermastro · WARDOGS Italian Gamer — All content on this site is exclusive property. Unauthorized copying or reproduction is forbidden.",
  "str.over": "// PROJECT MAIN CHANNEL",
  "str.schedule_title": "Live Schedule",
  "str.schedule_empty": "No scheduled dates right now — the Quartermaster updates the schedule week by week.",
  "str.sched_today": "Today",
  "str.sched_tomorrow": "Tomorrow",
  "str.kind_live": "Live",
  "str.kind_off": "No stream",
  "str.kind_special": "Special",
  "str.text": "The operational command of the WARDOGS community. Streams, events, previews and official giveaways: everything starts here.",
  "str.status": "Channel status",
  "str.follow": "Follow to catch every stream",
  "str.sub_note": "Channel subscribers unlock access to the headquarters giveaways. Verification happens automatically with Twitch login.",
  "str.open": "Open on Twitch",
  "str.subscribe": "Subscribe — unlock giveaways",
  "str.live": "LIVE",
  "str.offline": "OFFLINE",
  "str.partners_over": "// PARTNER STREAMERS",
  "str.partners_title": "The squad is growing",
  "str.partners_text": "Project partner streamers are added as they join the company. Want in? Reach out on Discord.",
  "str.slot": "Open slot",
  "str.slot_sub": "Next partner incoming",
  "str.watch": "Watch the stream",
  "yt.over": "// VIDEO ARCHIVE — OFFICIAL BULKHEAD CHANNEL",
  "yt.title1": "The",
  "yt.title2": "BULKHEAD archive",
  "yt.text": "Every video the software house publishes about WARDOGS is loaded here automatically, straight from the official YouTube channel.",
  "yt.sync": "Syncing archive…",
  "yt.live": "Live feed — {n} videos synced",
  "yt.down": "Archive temporarily unreachable",
  "yt.latest": "Latest upload",
  "yt.watch": "Watch on YouTube",
  "yt.play": "Play",
  "yt.channel": "Go to the BULKHEAD channel",
  "com.over": "// COMMUNITY REGISTRY",
  "com.title1": "Choose your",
  "com.title2": "faction",
  "com.text": "Swear allegiance to one of the three factions and your name enters the headquarters' public registry. Your chosen faction can be changed once every 30 days.",
  "com.gate_title": "Enter the headquarters",
  "com.gate_text": "Sign in with Twitch, Google or Discord, pick your faction and unlock the perks reserved for operators. One click and you're in.",
  "com.welcome": "Operator {name} — select a faction",
  "com.cooldown": "Active faction: {role} — you can switch faction in {days} days (one change every 30 days)",
  "com.discord_notice_title": "Faction role on Discord",
  "com.discord_notice_text": "Want your faction role on the Discord server? Link your Discord account from your Profile: the Lonestar, Valkyra or Manticore role is assigned automatically. Already picked a faction? You'll get the role as soon as you link.",
  "com.discord_notice_cta": "Link Discord",
  "com.assigned": "Faction assigned: {role}",
  "com.locked_toast": "Change locked: you can switch faction in {n} days.",
  "com.error": "Could not assign the faction.",
  "com.auth_ok": "Signed in. Welcome to headquarters.",
  "com.auth_denied": "Twitch sign-in cancelled.",
  "com.active": "▸ Active faction",
  "com.locked": "▸ Change locked (30 days)",
  "com.select": "▸ Select",
  "com.roster_over": "// OPERATOR REGISTRY",
  "com.roster_title": "The faction wall",
  "com.enrolled": "{n} enlisted operators",
  "com.waiting": "Awaiting recruits",
  "com.ops": "{n} OP",
  "com.new_badge": "New",
  "com.today_names": "Joined today (Twitch / Google / Discord login)",
  "role.lonestar.desc": "Surgical precision. The faction's eyes and rifle.",
  "role.valkyra.desc": "Assault fury. First line, first impact, last word.",
  "role.manticore.desc": "Support and control. Your six, always covered.",
  "gv.over": "// REWARDS VAULT",
  "gv.title": "The giveaway vault",
  "gv.text": "Rewards are visible to everyone, but the vault only opens for subscribers of the Quartermaster's Twitch channel — automatic verification, exactly like on Discord.",
  "gv.active": "Active giveaway",
  "gv.soon": "In preparation",
  "gv.loading": "Loading reward…",
  "gv.prize": "Prize",
  "gv.entries": "{n} entries",
  "gv.login_title": "Sign-in required",
  "gv.login_text": "Sign in with Twitch: we'll automatically check your channel subscription.",
  "gv.in_title": "You're in",
  "gv.in_text": "Entry registered, {name}. The winner will be drawn live on the channel.",
  "gv.unlocked": "Vault unlocked",
  "gv.subs_title": "Subscribers only",
  "gv.subs_text": "Clicking \"Enter\" verifies your subscription to twitch.tv/ilquartiermastro through the official Twitch API.",
  "gv.enter": "Enter the giveaway",
  "gv.checking": "Checking subscription…",
  "gv.sub_link": "Not subscribed? Subscribe here",
  "gv.how1t": "Sign in with Twitch",
  "gv.how1x": "One click, no new password: we use your Twitch account.",
  "gv.how2t": "Automatic verification",
  "gv.how2x": "The Twitch API confirms your channel subscription in real time.",
  "gv.how3t": "Live draw",
  "gv.how3x": "The winner is drawn live on the Quartermaster's channel.",
  "gv.past": "Past giveaways",
  "gv.winner": "Winner: {name}",
  "gv.no_winner": "Not drawn yet",
  "gv.drawing": "Draw in progress — the wheel is spinning",
  "gv.wheel_sub": "Names are spinning… the wheel slows down and lands on the winner",
  "gv.winner_is": "The winner is",
  "gv.winner_sub": "Congratulations! The staff will contact you on Discord or Twitch to deliver the prize",
  "gv.sound_on": "Enable giveaway sounds",
  "gv.sound_off": "Mute giveaway sounds",
  "gv.showcase_label": "Latest community winner",
  "gv.showcase_won": "Takes home",
  "gv.showcase_next": "No active giveaway right now — the next one is being prepared, check back soon",
  "gv.hof": "Hall of Fame — giveaway winners",
  "gv.hof_last": "Latest winner",
  "gv.audio_hint": "Click or tap the page once to enable giveaway sounds",
  "gv.audio_overlay": "Click to enable the wheel audio",
  "gv.audio_skip": "watch without audio",
  "gv.fair": "Cryptographic random draw across {n} entrants — equal odds for everyone",
  "gv.wheel_ready": "Every entrant takes a slice of the wheel — it updates automatically on each new entry",
  "gv.volume": "Sound volume",
  "gv.under_pointer": "Under the pointer",
  "gv.joined": "jumped on the wheel!",
  "gv.toast_in": "Entry confirmed. Good luck!",
  "gv.toast_already": "You're already in: good luck, operator.",
  "gv.toast_notsub": "An active channel subscription is required to enter.",
  "gv.toast_relogin": "Twitch session expired: log out and back in with Twitch, then retry. If you're subscribed (Prime included) you'll get in.",
  "gv.toast_error": "Error while entering.",
  "g10.p1": "We will NOT monetize the game at any point during Early Access.",
  "g10.p2": "We will NEVER monetize in-game cash or gold bars: they are earned by playing, and playing only.",
  "g10.p3": "We will NEVER let anyone buy camos directly: they must prove the commitment of those who unlocked them, not their wallet.",
  "gv.none": "No active giveaway right now — the next one is being prepared",
  "gv.participants": "Participants",
  "gv.no_participants": "No participants yet — be the first to enter",
  "gv.scheduled_badge": "Scheduled opening",
  "gv.starts_in": "Entries open in",
  "gv.not_open": "The vault is sealed: entries open automatically when the countdown ends.",
  "gv.toast_notopen": "Entries are not open yet.",
  "clips.over": "// FUNNY CLIPS",
  "clips.title": "The Quartermaster's clips",
  "clips.text": "The most absurd and spectacular live moments, pulled automatically from the Twitch channel.",
  "clips.by": "clipped by {name}",
  "clips.views": "{n} views",
  "clips.none": "No clips available right now — the best live moments will appear here automatically.",
  "profile.visits": "Total visits",
  "profile.badges_title": "Loyalty ranks — 10 tiers",
  "profile.badge_next": "Next rank at {n} visits",
  "profile.badge_max": "Highest rank reached",
  "steam.title": "Steam account",
  "steam.text_off": "Link your Steam account to show your WARDOGS playtime, achievements and stats. Steam never receives or shares your password: sign-in happens on Steam's official site.",
  "steam.link": "Link Steam account",
  "steam.hours": "Hours on WARDOGS",
  "steam.achievements": "Achievements unlocked",
  "steam.stats": "Game stats",
  "steam.no_stats": "The game doesn't publish stats on Steam yet — they'll appear here automatically once available.",
  "steam.not_owned": "WARDOGS not detected in your Steam library yet.",
  "steam.private": "Your Steam profile is private: some data may not be visible.",
  "steam.refresh": "Refresh",
  "steam.unlink": "Unlink",
  "steam.view": "Steam profile",
  "steam.toast_linked": "Steam account linked.",
  "steam.toast_error": "Steam linking failed. Try again.",
  "steam.toast_clash": "This Steam account is already linked to another user.",
  "steam.toast_unlinked": "Steam account unlinked.",
  "member.back": "Back to the registry",
  "member.notfound": "Operator not found",
  "member.since": "In the registry since {date}",
};

const dictionaries = { it, en };

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("lang");
    if (saved) return saved;
    // Lingua automatica: italiano solo per browser italiani, inglese per tutti gli altri
    return (navigator.language || "it").toLowerCase().startsWith("it") ? "it" : "en";
  });
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setOverrides(data.texts || {})).catch(() => {});
  }, []);

  const t = (key, vars = {}) => {
    const ov = overrides[key];
    // se lo Staff ha salvato la riga (anche VUOTA), vince la sua versione:
    // stringa vuota = testo nascosto sul sito, niente fallback al default
    const hasOv = ov && typeof ov === "object" && Object.prototype.hasOwnProperty.call(ov, lang);
    let str = hasOv
      ? ov[lang]
      : (Object.prototype.hasOwnProperty.call(dictionaries[lang] || {}, key)
          ? dictionaries[lang][key]
          : (Object.prototype.hasOwnProperty.call(dictionaries.it, key) ? dictionaries.it[key] : key));
    // attenzione: anche i valori di dizionario intenzionalmente VUOTI (es. link non
    // ancora impostato) devono restare stringa vuota, mai il nome della chiave
    for (const [k, v] of Object.entries(vars)) str = str.replaceAll(`{${k}}`, v);
    return str;
  };

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
